
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ajanvaraus",
      function () {
        return require("private-next-pages/ajanvaraus.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ajanvaraus"])
      });
    }
  